import { ClassTypeOptions, ra, ra_property } from '@cundd/rest-adapter';
import { Department } from './Department';
import { Industry } from './Industry';
import { JobCenterModelInterface } from './JobCenterModelInterface';

@ra(ClassTypeOptions.AddUnknownFields)
export class Candidate implements JobCenterModelInterface {
    @ra_property()
    public referenceId: string = '';

    @ra_property()
    public title: string = '';

    @ra_property()
    public creationDate?: Date;

    @ra_property()
    public education: string = '';

    @ra_property()
    public yearOfBirth: number = 0;

    @ra_property()
    public careerAspiration: string = '';

    @ra_property()
    public languages: string = '';

    @ra_property()
    public additionalInformation: string = '';

    @ra_property()
    public highlight: boolean = false;

    @ra_property()
    public uri: string = '';

    @ra_property(Department)
    public department?: Department;

    @ra_property(Industry)
    public industry?: Industry;

    @ra_property()
    public contextLanguage: string = '';

    public getPaginationItemKey(): string {
        return this.referenceId;
    }
}
